// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1eABM","icon":"style_icon__17dQs","avatar":"style_avatar__4b8w8","menuIcon":"style_menuIcon__1leGN"};